/** @jsx jsx */

import { css as _css, keyframes } from 'emotion';
import { css, jsx } from '@emotion/core';

// const lineWeight = 5;

const dualRingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const dualRing = (size, color, lineWeight) => _css`
  {
    display: inline-block;
    width: ${size}px;
    height: ${size}px;
    animation: 1.2s linear infinite;
  }
  &:after {
    content: "";
    display: block;
    width: ${size - lineWeight * 2}px;
    height: ${size - lineWeight * 2}px;
    border-radius: 50%;
    border: ${lineWeight}px solid ${color};
    border-color: ${color} transparent ${color} transparent;
    animation: ${dualRingAnimation} 1.2s linear infinite;
  }
`;

interface ILoadingSpinnerProps {
  size?: number;
  color?: string;
  lineWeight?: number;
}

const LoadingSpinner = ({
  size = 46,
  color = '#cea5f9',
  lineWeight = 5,
}: ILoadingSpinnerProps) => (
  <div
    css={css`
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    `}
  >
    <div className={dualRing(size, color, lineWeight)} />
  </div>
);

export default LoadingSpinner;
